import { InjectionKey } from 'vue';
import ActivityService from './activity.service';

export const activityServiceServiceKey = Symbol() as InjectionKey<ActivityService>;
